module.exports = __webpack_public_path__ + "img/1557394864.66c1bc76.jpg";